/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  IComponentGridInventory,
  IInventoryDetailsSettings,
  IInventorySettings,
  ILayoutBase,
  ILink,
  ILinkGroup,
  InventoryLocations,
} from '@lamesarv-sdk/types';

// -- Layout Utilities

export interface ILayoutGridSettings {
  inventoryNotFound: IInventorySettings;
  inventorySold: IInventorySettings;
  inventoryNotAvailable: IInventorySettings;
  inventoryLanding: IComponentGridInventory;
}

export interface INavBarLink extends ILink {
  childrenPages?: string[];
}

export interface IContactItem {
  title: string;
  text: string;
  url: string;
  default?: boolean;
  show_on_mobile?: boolean;
  always_include?: boolean;
  classes?: string;
  classes_icon?: string;
  custom_item?: boolean;
  inventory_status?: string;
  inventory_maker?: string;
  inventory_model?: string;
  inventory_title_contains?: string;
  page_title_contains?: string;
}

// -- Layout

export interface ILayoutHeader {
  logo: string;
  slogan: string;
  searchPlaceholder?: string;
  sidebarLinks: ILink[];
  sidebarAdditionalLinks: ILink[];
  navBarLinks: INavBarLink[];
  contactItems: IContactItem[];
}

export interface ILayoutFooter {
  logo: string;
  copyright: string;
  linksGroups: { [groupKey: string]: ILinkGroup | ILinkGroup[] };
  socialLinks: ILinkGroup;
  footerLinks: ILink[];
  additionalLogos: {
    imageUrl: string;
    classes?: string;
  }[];
  // -- legacy - Remove
  rightFooterLinks?: ILink[];
}

export interface ILayout extends ILayoutBase {
  header: ILayoutHeader;
  footer: ILayoutFooter;
  isPreview?: boolean;
  // Legacy - Migrate to ILayoutInventory
  gridSettings: ILayoutGridSettings;
  inventoryDetailsSettings: IInventoryDetailsSettings & {
    displaySubscribeCheckbox: boolean;
    subscribeCheckboxContent: string;
    displaySmsCheckbox: boolean;
    customSmsText: string;
    feeInclusiveContentCards?: string;
    feeInclusiveContentPdp?: string;
  };
  noPriceButtonContent?: string;
}

export interface ILayoutInventory {
  gridSettings: {
    inventoryNotAvailable: IInventorySettings;
    inventoryNotFound: IInventorySettings;
    inventorySold: IInventorySettings;
    inventoryLanding: IInventorySettings;
  };
  inventoryDetailsSettings: {
    bodyStyleIcon: string;
    engineIcon: string;
    fuelTypeIcon: string;
    lengthIcon: string;
    mileageIcon: string;
    sleepsIcon: string;
    slideoutsIcon: string;
    weightIcon: string;
    legalCheckboxContent: string;
    subscribeCheckboxContent: string;
    displaySmsCheckbox: boolean;
    customSmsText: string;
  };
  noPriceButtonContent: string;
}

// -- Context

export interface ILayoutContextData {
  contactItems?: IContactItem[];
  defaultContactItem?: IContactItem;
  geoLocation?: [number, number];
  isGeoLocationLoading?: boolean;
  isComparisonModalOpen?: boolean;
  noPriceButtonContent?: string;
  utmData?: { [utmKey: string]: string };
  inventoryLocations: InventoryLocations;
  detailsSettings: IInventoryDetailsSettings & {
    displaySubscribeCheckbox: boolean;
    subscribeCheckboxContent: string;
    displaySmsCheckbox: boolean;
    customSmsText: string;
    feeInclusiveContentCards?: string;
    feeInclusiveContentPdp?: string;
  };
  isEmbed?: boolean;
}

export enum LayoutReducerActionType {
  updateGeoLocation = 'updateGeoLocation',
  updateGeoLocationLoading = 'updateGeoLocationLoading',
  updateIsModalOpen = 'updateIsModalOpen',
  updateUtmData = 'updateUtmData',
  updateDefaultContactItem = 'updateDefaultContactItem',
}

export interface ILayoutReducerAction {
  type: LayoutReducerActionType;
  payload?: any;
}
